import { useState } from "react";

export function useSimulateLoading() {
	const [loadingPercentage, setLoadingPercentage] = useState(0);
	const [longLoadingRequest, setLongLoadingRequest] = useState(false);

	let progress = 10; // Start progress at 10%

	const simulateLoading = (targetPercentage, intervalTime = 500) => {
		return new Promise((resolve) => {
			const interval = setInterval(() => {
				if (progress < targetPercentage) {
					progress += 1; // Increase by 1% every interval
					setLoadingPercentage(progress);
				} else {
					clearInterval(interval);
					resolve(); // Stop when reaching the target percentage
				}
			}, intervalTime); // Adjust interval time for smoother/slower increments
		});
	};

	return {
		progress,
		loadingPercentage, setLoadingPercentage,
		longLoadingRequest, setLongLoadingRequest,
		simulateLoading
	}
}